const SWR_KEY = {
  SEARCH_BLOG: '/blog/search',
  GET_DETAIL_BLOG: '/blog/detail',

  // Token
  GET_TOKEN_LIST: '/blockchain/user/token-list',
  GET_FIAT_LIST: '/blockchain/user/fiats',
  GET_ALO_WALLET: '/blockchain/user/token-alo',
  CONVERT_AMOUNT: '/blockchain/user/currency/convert',

  // payment
  GET_PAYMENT_LIST: '/blockchain/user/bank-list',
  CREATE_PAYMENT: '/blockchain/user/create-bank',
  UPDATE_PAYMENT: '/blockchain/user/bank-update',
  DELETE_PAYMENT: '/blockchain/user/bank-delete',
  GET_CHAIN_LIST: '/blockchain/user/token-networks',
  GET_WALLET: '/blockchain/user/get-wallet',
  GET_BANK_LIST: '/blockchain/bank-list',

  // Order
  CREATE_ORDER: '/blockchain/user/create-order',
  GET_ORDER_LIST: '/blockchain/user/list-order',
  GET_ORDER_DETAIL: '/blockchain/user/detail-order',
  CANCEL_ORDER: '/blockchain/user/cancel-order',
  VERIFY_PI_TRANSACTION: '/blockchain/user/verify-pi-transaction/',

  // User
  GET_ME: '/blockchain/user/me',
  LOGIN: '/blockchain/user/login',
  REGISTER: '/blockchain/user/register',
  KYC: '/blockchain/user/kyc-request',
  NOTIFICATION: '/blockchain/user/notifications',
  REFERRAL: '/referral-tree',
  FORGOT_PASSWORD: '/blockchain/user/forgot-password',
  CHANGE_PASSWORD: '/blockchain/user/change-password',

  UPLOAD: '/blockchain/file/upload',

  // Check-in
  CHECK_IN_LIST: 'blockchain/user/checkins/days',
  CHECKED_IN: 'blockchain/user/checkin',

  // check
  STATS_PROCESSING: '/blockchain/user/sell-orders/stats-processing',
  ORDER_BY_STATUS: '/blockchain/user/sell-orders/orders-by-status',
  CLOSED_ORDER_DAYS: '/blockchain/user/sell-orders/closed-days',

  // Merchant
  MERCHANT_LIST: '/blockchain/user/merchant/list',
  MERCHANT_CREATE: '/blockchain/user/merchant/create',
  MERCHANT_UPDATE: '/blockchain/user/merchant/update',
  MERCHANT_DELETE: '/blockchain/user/merchant/delete',

  // Wallet
  GET_TOKEN_WALLET: '/blockchain/user/wallet/token-list',

  // Transaction
  SYNC_BSC: '/blockchain/user/wallet/sync-transaction-bsc',
  SYNC_TRX: '/blockchain/user/wallet/sync-transaction-trx',
  DEPOSIT_TRANSACTION: '/blockchain/user/wallet/transactions',
}

export default SWR_KEY

export const FAST_INTERVAL = 10000
export const MID_INTERVAL = 30000
export const SLOW_INTERVAL = 60000
